import { Link } from 'react-router-dom';

interface Step {
  title: string;
  items: string[];
}

const STEPS: Step[] = [
  {
    title: '1. Registrati e verifica il tuo account',
    items: [
      'Clicca su "Registrati" e inserisci il tuo Nickname, Email e Password.',
      'Inserisci il tuo numero di cellulare: riceverai immediatamente un codice SMS (OTP).',
      'Inserisci il codice sulla piattaforma per attivare il tuo profilo e blindare la tua sicurezza.',
    ],
  },
  {
    title: '2. Riscatta i tuoi 7 minuti gratis',
    items: [
      'Una volta completata la verifica OTP, troverai automaticamente 7 minuti di consulto omaggio nella tua area personale.',
      'Puoi visualizzare questo regalo nella sezione "Le mie Promozioni".',
      'Scegli l\'operatore che preferisci e avvia la tua prima chiamata senza spendere un centesimo!',
    ],
  },
  {
    title: '3. Fai la tua prima ricarica (offerta speciale 0,99€)',
    items: [
      'Vuoi continuare il consulto? Per la tua prima ricarica, Klaro7 ti offre una tariffa esclusiva di 0,99€ al minuto.',
      'Esempio: ricarichi 10€ e ne ricevi 17€ totali di credito, tutto utilizzabile alla tariffa bloccata di 0,99€ fino a esaurimento!',
      'Puoi ricaricare con Carta di Credito, Postepay o PayPal per avere il credito immediato.',
    ],
  },
  {
    title: '4. Scegli il tuo consulente',
    items: [
      'Sfoglia i profili dei nostri esperti in Cartomanzia e Astrologia.',
      'Controlla il "pallino": se è Verde, il consulente è disponibile per te in tempo reale.',
    ],
  },
  {
    title: '5. Privacy e riservatezza al 100%',
    items: [
      'Parla in totale libertà: il consulente vedrà solo il tuo Nickname.',
      'Il tuo numero di telefono e i tuoi dati personali rimarranno sempre segreti e protetti.',
    ],
  },
];

const TIPS: string[] = [
  'Controlla la scadenza: i tuoi bonus sono validi per 20 giorni dalla data di attivazione.',
  'Argomenti: ricorda che i nostri consulenti non possono trattare temi legati alla salute o a questioni legali.',
  'Supporto: se hai problemi con l\'SMS di verifica o con la ricarica, scrivi subito a assistenza@klaro7.com.',
];

export function GuidePage() {
  return (
    <div className="text-brand-navy">
      <section className="px-4 py-10">
        <div className="mx-auto max-w-3xl">
          {/* Welcome banner */}
          <div className="rounded-2xl bg-gradient-to-r from-brand-navy via-[#1c1a4d] to-brand-teal-600 px-6 py-10 text-white shadow-lg md:px-10">
            <p className="text-sm font-semibold uppercase tracking-wide text-white/70">
              Benvenuto su Klaro7
            </p>
            <h1 className="mt-1 text-2xl font-bold md:text-3xl">Guida ai tuoi primi passi</h1>
            <p className="mt-3 max-w-xl text-sm text-white/80">
              In pochi minuti sei pronto per il tuo primo consulto. Segui questi semplici passaggi.
            </p>
          </div>

          {/* Steps */}
          <div className="mt-8 space-y-4">
            {STEPS.map((step) => (
              <div
                key={step.title}
                className="rounded-2xl border border-neutral-200 bg-white px-6 py-6 shadow-sm"
              >
                <h2 className="text-lg font-bold text-brand-navy">{step.title}</h2>
                <ul className="mt-3 space-y-2">
                  {step.items.map((item, i) => (
                    <li key={i} className="flex gap-3 text-sm text-neutral-700">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-teal" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Tips */}
          <div className="mt-6 rounded-2xl border border-brand-orange/30 bg-brand-orange/5 px-6 py-6">
            <h2 className="text-lg font-bold text-brand-navy">Consigli utili per la tua prima volta</h2>
            <ul className="mt-3 space-y-2">
              {TIPS.map((tip, i) => (
                <li key={i} className="flex gap-3 text-sm text-neutral-700">
                  <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-orange" />
                  <span>{tip}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div className="mt-8 flex flex-col items-center gap-3 text-center">
            <p className="text-sm font-semibold text-brand-navy">
              Sei pronto? Il tuo primo consulto di 7 minuti ti aspetta.
            </p>
            <Link
              to="/consulenti"
              className="inline-flex min-h-[44px] items-center rounded-lg bg-brand-orange px-6 py-2.5 text-sm font-bold text-white transition-colors hover:bg-brand-orange/90"
            >
              Inizia ora
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
